
(global => {

  global.tree = {};

  /**
  * Drag & drop для списка объектов проводника
  * @namespace Core.tree.dragging
  * @since 5.8.2.9042
  */
  global.tree.dragging = class {
    constructor() {
      /** 
       *@property {string} draggable селектор для обновления дерева
       *@property {object} JDraggable перетаскиваемые объекты
       *@property {boolean} isCopyKeyPressed кнопка копирования нажата
       *@property {boolean} isCancelKeyPressed кнопка отмены нажата
       */
      this.draggable = '.tree__node-content';
      this.jDraggable = null;
      this.isCopyKeyPressed = false;
      this.isCancelKeyPressed = false;

      if (WA.ENV.isTouch()) {
        log.info('DRAG&DROP', 'Drag & Drop is disabled for touch devices');
        return;
      }
      log.info('DRAG&DROP', 'Folder tree Drag & Drop initializing');
      if (WA.getLocation() === 'explorer') {
        this.initDragging();
      }
      WA.CR.folderTree.bind('itemsChange', () => { this.initDragging(); })
    }

    /**
     * Инициализирует перетаскивание папок дерева папок.
     * */
    initDragging() {
      this.refreshObjects();
      this.dragSetup();
      this.dropSetup();
    }

    /**
    * Обновить jquery объекты, когда обнвовляется дерево
    * @function Core.tree.dragging.refreshObjects
    * @since 5.8.2.9042
    * @return {Core.folderTree.dragAndDrop}
    */
    refreshObjects() {
      this.jDraggable = $(this.draggable).not('drag_binded');
      return this;
    }

    /**
    * Настройка элементов, которые можно перетаскивать
    * Здесь же в функции helper формируется представление переносимого
    * объекта.
    * @function Core.tree.dragging.dragSetup
    * @since 5.8.2.9042
    * @return {Core.tree.dragging}
    * @see http://goo.gl/QIkKPS
    */
    dragSetup() {
      const settings = {
        helper() {
          const jAttachedToCursorItem = $('<div class="movedStack"></div>');
          jAttachedToCursorItem.append($(this).clone().addClass('movedItem'));
          return jAttachedToCursorItem;
        },
        revert: 'invalid',
        cursorAt: { left: 13, top: 13 },
        cursor: 'grabbing',
        distance: 10,
        cancel: '.fastActions',
      }
      this.jDraggable.draggable(settings).addClass('drag_binded');
      return this;
    }

    /**
    * Настройка элементов, В(!) которые можно перетаскивать
    * @function Core.folderTree.tree.dropSetup
    * @since 5.8.2.9042
    * @return {Core.folderTree.tree}
    */
    dropSetup() {
      Core.dropping.init();
      return this;
    }
  }

})(window.Core);


